module.exports = __webpack_public_path__ + "img/direto-no-pc.0353a4f8.png";